import React, { useState, useEffect, useCallback } from 'react';
import { Card, Row } from 'react-bootstrap';
import VerifiedIcon from '../assets/icons/verified-icon.svg';
import {getSimilarProfiles} from '../services/api';
import ArrowRightUp from '../assets/icons/ArrowRightUp_24px.svg';

const SimilarProfiles = ({ influencerId, platformAccountType }) => {
    const [creators, setCreators] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getSimilarProfiles(influencerId, platformAccountType);

                if (response.status === 404) {
                    setCreators([]);
                    setError("Profile not found. Please check the influencer ID.");
                } else {
                    const shuffledCreators = response.data.sort(() => Math.random() - 0.5);
                    setCreators(shuffledCreators);
                    setError(null);
                }
            } catch (error) {
                setCreators([]);
                setError("An error occurred while fetching the details.");
            }
        };

        fetchData();
    }, [influencerId, platformAccountType]);

    const formatFollowers = useCallback(count => {
        if (count >= 1000000000) {
            return (count / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B'; // Format as billions
        } else if (count >= 1000000) {
            return (count / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'; // Format as millions
        } else if (count >= 1000) {
            return (count / 1000).toFixed(1).replace(/\.0$/, '') + 'K'; // Format as thousands
        } else {
            return count; // Less than 1000, no suffix
        }
    }, []);
    return (
        creators.length > 0 && (
        <Card id="similar-profiles" className="border rounded-0">
            <Card.Body className='p-3'>
                <div className="creator-look-alike audience-section">
                    <div className="header">
                        <h6 className="sub-heading" >Creator similar contents</h6>
                    </div>
                    <Row className="d-flex flex-wrap overflow-container justify-content-start gap-1 p-0 py-2 m-0 mt-4 border audience-border-radius">
                        {creators.map(creator => (
                            <div key={creator.id} className='w-100 py-2 border-bottom'>
                                <div className="profile">
                                    <div className="ellipse-parent d-flex align-items-center gap-2">
                                        <img className="frame-child rounded-circle" alt="" src={creator.imageUrl} style={{ width: '48px', height: '48px' }} />
                                        <div className="frame-parent w-100">
                                            <div className='d-flex justify-content-between'>
                                            <div className="peteran-parent d-flex align-items-center justify-content-between gap-0">
                                                <div className="creator-platformname text-black me-0">{creator.platformUsername}</div>
                                                {creator.isVerified && <img src={VerifiedIcon} alt="Verified" className="verified-icon" width={16} height={16}/>}
                                            </div>
                                            <a src={creator.url} target='_blank' className='cursor-pointer'><img src={ArrowRightUp} alt="Arrow" width={24} height={24}/></a>
                                            </div>
                                            <small className="creator-followers text-muted mt-0">{formatFollowers(creator.followerCount)} followers</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Row>
                </div>
            </Card.Body>
        </Card>
        )
    );
};

export default SimilarProfiles;